module.exports = __webpack_public_path__ + "img/keyboard_65_fluffy.c6ac45a8.png";